import type { InfiniteData, Query, QueryClient } from "@tanstack/react-query";
import type { Catalog } from "@/entities/thread/types";

export const THREADS_QUERY_KEY = ["threads"] as const;
export const INFINITE_CATALOG_QUERY_KEY_PREFIX = [
  ...THREADS_QUERY_KEY,
  "infinite",
] as const;

function hasInfiniteCatalogQueryPrefix(query: Query): boolean {
  const { queryKey } = query;
  return (
    queryKey[0] === THREADS_QUERY_KEY[0] &&
    queryKey[1] === INFINITE_CATALOG_QUERY_KEY_PREFIX[1]
  );
}

function isInfiniteCatalogQuery(query: Query): boolean {
  return query.queryKey.length === 5 && hasInfiniteCatalogQueryPrefix(query);
}

/**
 * mutation後は追記済みの後続ページを捨て、先頭ページだけを再検証する。
 * これにより削除済みスレッドを残さず、取得数も表示ページ数に比例させない。
 */
export async function invalidateCatalogQueries(
  queryClient: QueryClient,
): Promise<void> {
  await queryClient.cancelQueries({
    predicate: hasInfiniteCatalogQueryPrefix,
  });
  queryClient.setQueriesData<InfiniteData<Catalog, number>>(
    { predicate: isInfiniteCatalogQuery },
    (data) => {
      const firstPage = data?.pages[0];
      if (!data || !firstPage) return data;
      return {
        pages: [firstPage],
        pageParams: [1],
      };
    },
  );
  await queryClient.invalidateQueries({ queryKey: THREADS_QUERY_KEY });
}
